import React, { useState } from "react";

// MUI Imports
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import CloseIcon from "@mui/icons-material/Close";

// Component Imports
import SuccessAlert from "../../../Components/Interactive/SuccessAlert";
import FailAlert from "../../../Components/Interactive/FailAlert";
import ToolTip from "../../../Components/Interactive/ToolTip";
import EditModal from "../../../Components/EditModal";

import { handlePropertyOptOut } from "./optOutApiHandlers";

const ResultRowProperty = ({
  idx,
  brand,
  row,
}) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [brandId] = useState(brand);
  const [modalIsOpen, setModalOpen] = useState(false);

  // Event Handlers - Modals
  const handleOpen = (e) => {
    clearMessages();
    setModalOpen(true);
  }
  const handleClose = (e) => {
    clearMessages();
    setModalOpen(false);
  }

  const clearMessages = async () => {
    setSuccessMessage(null);
    setErrorMessage(null);
  };

  return (
    <>
    <EditModal open={modalIsOpen} handleClose={handleClose} customCSS={{height: "625px"}}>
    <div>
    {
        successMessage ?
        (
          <SuccessAlert>
            {successMessage}
          </SuccessAlert>
        )
        :
        errorMessage ?
          (
            <FailAlert>{errorMessage}</FailAlert>)
          : null
     }
    </div>      
      <div className="modal-header">
        <h2 style={{ padding: ".5rem", color: "#6acde6"}}>Opt Out</h2>
        <CloseIcon
          className="close-icons"
          onClick={() => handleClose()}
        />
      </div>
      <div className="data-highlight">
        <h6>Brand</h6>
        <p>{brand}</p>
        <br/>
        <h6>Full Address</h6>
        <p>{row.propertyDetails.subjectAddress}</p>
        <br/>
        <h6>Street</h6>
        <p>{row.propertyDetails.fullAddress}</p>
        <br/>
        <h6>City</h6>
        <p>{row.propertyDetails.city}</p>
        <br/>
        <h6>State</h6>
        <p style={{ whiteSpace:"pre-wrap"}}>{row.propertyDetails.state}</p>
        <br/>
        <h6>Zip</h6>
        <p>{row.propertyDetails.postalCode}</p>
        <br/>
      </div>
      <button
        className="submit-note-btn moveRight"
        onClick={(e) => handlePropertyOptOut(row.propertyDetails.fullAddress, row.propertyDetails.city, row.propertyDetails.state, row.propertyDetails.postalCode, setSuccessMessage, setErrorMessage, clearMessages, brandId)}
      >
        <span style={{ color: "#fff" }}>Submit Opt Out</span>
      </button>
    
  </EditModal>
    <TableRow className="order-row table-row" key={idx}>
      <ToolTip
        placement="top"
        titleHeading="Full Address"
        titleData={row.propertyDetails.subjectAddress}
        >
      <TableCell align="center" className="tableCell">
        {row.propertyDetails.subjectAddress}
      </TableCell>
      </ToolTip>
      <ToolTip
        placement="top"
        titleHeading="City"
        titleData={row.propertyDetails.city}
        >
      <TableCell align="center" className="tableCell">
        {row.propertyDetails.city}
      </TableCell>
      </ToolTip>
      <ToolTip
        placement="top"
        titleHeading="City"
        titleData={row.propertyDetails.state}
        >
      <TableCell align="center" className="tableCell">
        {row.propertyDetails.state}
      </TableCell>
      </ToolTip>
       <ToolTip
        placement="top"
        titleHeading="Zip"
        titleData={row.propertyDetails.postalCode}
        >
      <TableCell align="center" className="tableCell">
        {row.propertyDetails.postalCode}
      </TableCell>
      </ToolTip>
      <TableCell className="tableCell" align="center">
        <button
            onClick={() => {handleOpen();}}
            className="update-lockout-btn"
          >
            <span>Opt Out</span>
        </button>
      </TableCell>
    </TableRow>
    </>
  );
};

export default ResultRowProperty;
